






















































































import {
  computed,
  defineComponent,
  nextTick,
  PropType,
  ref
} from '~/utils/nuxt3-migration'
import { AuditRequest } from '~/models/audit/request'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import AuditRequestService from '~/services/audits/AuditRequestService'
import { useDep } from '~/compositions/dependency-container'
import { useSnackbar } from '~/compositions/snackbar'
import { useRequestError } from '~/compositions/request-error'
import { useI18n } from '~/compositions/i18n'
import { useRoute } from '@nuxtjs/composition-api'
import CancelAuditButton from '~/components/shared/audits/request/timeline/CancelAuditButton.vue'
import PayAuditButton from '~/components/shared/audits/request/timeline/PayAuditButton.vue'
import ShowAuditInClassifiedToggle from '~/components/shared/audits/request/timeline/ShowAuditInClassifiedToggle.vue'

export default defineComponent({
  components: {
    ShowAuditInClassifiedToggle,
    PayAuditButton,
    CancelAuditButton,
    CConfirmationModal
  },
  props: {
    request: {
      type: Object as PropType<AuditRequest>,
      required: true
    }
  },
  setup(_, { emit }) {
    const isAcceptConfirmationVisible = ref(false)
    const selectedRequest = ref<AuditRequest | null>(null)
    const auditRequestService = useDep(AuditRequestService)
    const handleRequestError = useRequestError()
    const route = useRoute()
    const { t } = useI18n()
    const snackbar = useSnackbar()
    const loading = ref(false)

    function handleAcceptRequest(request: AuditRequest) {
      selectedRequest.value = request
      isAcceptConfirmationVisible.value = true
    }

    async function acceptAuditRequest() {
      try {
        loading.value = true
        const { id } = selectedRequest.value
        const { auditRequest } = await auditRequestService.acceptAuditRequest(
          id
        )

        emit('request-updated', auditRequest)

        snackbar.success(t('acceptance_audit_successful'))
        await nextTick()
      } catch (e) {
        handleRequestError(e)
      } finally {
        loading.value = false
        selectedRequest.value = undefined
      }
    }

    const inAccount = computed(
      () => route.value.name === '__account_audits_requests'
    )

    return {
      handleAcceptRequest,
      inAccount,
      isAcceptConfirmationVisible,
      acceptAuditRequest,
      loading
    }
  }
})
